import React, { Component } from 'react';
import { Table, Row, InputNumber } from 'antd';
import Compared from "../../Compared";


Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.date,
            data: [],
            loading: true,
            note: { note: "" },
            note8_2: { comments: "" },
            loadingSave: false,
            print: false
        }
    }

    onChange = (name, value, i) => {
        let data = this.props.data;
        data[i][name] = value;

        this.props.onChange(data);
    }

    render() {
        const data = this.props.data;
        const width = document.body.offsetWidth > 2050 ? document.body.offsetWidth - 1650 : 400;
        const columns = [{
            title: 'Cost of Maintenance 维修费用统计',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding `} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div> Current Month Actual <br /> This Year 本年当月实际数 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'year_now_actual',
                key: 'year_now_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Current Month Actual This Year 本年当月实际数', 'RMB 费用（元）'];

                    return (
                        <Compared data={{ index, key: 'year_now_actual', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('year_now_actual', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div>Last Month Actual - Current Year<br /> 本年上月实际数 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'year_last_actual',
                key: 'year_last_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Last Month Actual - Current Year 本年上月实际数', 'RMB 费用（元）'];

                    return (
                        <Compared data={{ index, key: 'year_last_actual', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('year_last_actual', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div> Current Month Actual - Last Year <br />   去年当月实际数 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'lastYear_now_actual',
                key: 'lastYear_now_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Current Month Actual - Last Year 去年当月实际数', 'RMB 费用（元）'];

                    return (
                        <Compared data={{ index, key: 'lastYear_now_actual', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('lastYear_now_actual', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div> YTD Actual - This Year <br />年累计实际 - 今年 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'year_actual',
                key: 'year_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - This Year 年累计实际 - 今年', 'RMB 费用（元）'];

                    return (
                        <Compared data={{ index, key: 'year_actual', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('year_actual', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div> YTD Actual - Last Year <br /> 年累计实际 - 去年 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'lastYear_actual',
                key: 'lastYear_actual',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Actual - Last Year 年累计实际 - 去年', 'RMB 费用（元）'];

                    return (
                        <Compared data={{ index, key: 'lastYear_actual', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('lastYear_actual', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div> Current Month Variance - This Year vs. Last Year  <br /> 当月差异 - 今年对比去年 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'lastYear_fee',
                key: 'lastYear_fee',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', 'RMB 费用（元）'];
                    return (
                        <Compared data={{ index, key: 'lastYear_fee', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className={`table-padding `} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: "% 百分比",
                dataIndex: 'lastYear_percent',
                key: 'lastYear_percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Current Month Variance - This Year vs. Last Year 当月差异 - 今年对比去年', '% 百分比'];
                    return (
                        <Compared data={{ index, key: 'lastYear_percent', title, sqlName: "_8_2_1", name: record.name, type: 'percent' }}>
                            <div className={`table-padding `} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div> Month Variance - This month vs. Last month  <br /> 月度差异 - 今年当月对比今年上月 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'year_fee',
                key: 'year_fee',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', 'RMB 费用（元）'];
                    return (
                        <Compared data={{ index, key: 'year_fee', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className={`table-padding `} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: "% 百分比",
                dataIndex: 'year_percent',
                key: 'year_percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['Month Variance - This month vs. Last month 月度差异 - 今年当月对比今年上月', '% 百分比'];
                    return (
                        <Compared data={{ index, key: 'year_percent', title, sqlName: "_8_2_1", name: record.name, type: 'percent' }}>
                            <div className={`table-padding `} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }],

        }, {
            title: <div> YTD Variance - This Year vs. Last Year   <br /> 年累计差异 - 今年对比去年 </div>,
            children: [{
                title: "RMB 费用（元）",
                dataIndex: 'last_fee',
                key: 'last_fee',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year  年累计差异 - 今年对比去年', 'RMB 费用（元）'];
                    return (
                        <Compared data={{ index, key: 'last_fee', title, sqlName: "_8_2_1", name: record.name, type: 'number' }}>
                            <div className={`table-padding `} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({Math.abs(text)})</span> : text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }
            }, {
                title: "% 百分比",
                dataIndex: 'last_percent',
                key: 'last_percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['YTD Variance - This Year vs. Last Year  年累计差异 - 今年对比去年', '% 百分比'];
                    return (
                        <Compared data={{ index, key: 'last_percent', title, sqlName: "_8_2_1", name: record.name, type: 'percent' }}>
                            <div className={`table-padding `} >
                                {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                            </div>
                        </Compared>
                    )
                }
            }],

        }];
        return (
            <div style={{ margin: "20px 0" }}>
                <Row style={{ width: this.props.print ? 2050 : 'auto', maxWidth: 2050 }}>
                    <Row>8.2 Cost of Maintenance 维修费用统计</Row>

                    <Table
                        columns={columns}
                        dataSource={data}
                        size="middle"
                        bordered
                        pagination={false}
                        className="content"
                        style={{ width: this.props.print ? 2050 : 'auto' }}
                        scroll={this.props.print ? {} : { x: 2050 }}
                        rowKey={(record, index) => index}
                    />
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/8.0/8-1/8-2.js